export const INPLAY_MATCHES_LIST = 'v1/events/matches/inplay';
export const TODAY_TOMMOROW_MATCHES_LIST = "v1/events/sports/all"
export const GET_CASINO_GAMES='api/get-casino-games';
export const GET_FAVOURITE_LIST = 'api/favorite-list';
export const MATCHES_BY_SPORT_ID = 'v1/events/matches/';
export const MAKE_FAVOURITE = 'api/make-match-favorite';
export const GET_MATCH_DETAILS = 'v1/events/matchDetails/';
export const PLACE_ORDER = 'api/place-order';
export const SAVE_BETS = 'api/save-bet';
export const GET_OPEN_BETS_BY_EVENT_ID='api/get-open-bets-by-event-id';
export const GET_FANCY_BOOK = 'api/get-fancy-book';
export const GET_EVENT_EXPOSURES = 'api/get-event-book-and-fancy-exposures-by-event-id/';
export const GET_PREMIUM_FANCY_URL = 'api/get-sap-premium-url';
export const  OPEN_BETS_EVENT_LISTING='api/open-bets-event-listing';
export const GET_SPORTS_BOOK_URL = 'api/get-sap-sportsbook-url';
export const  BET_CASHOUT='api/cashout';




